/**
 * Selettore del tipo di grafico. Solo UI + callback: NON calcola quali tipi
 * siano abilitati (lo fa il genitore e passa `enabled`). I tipi non abilitati
 * sono mostrati DISABILITATI, non nascosti.
 */

import { Radio } from 'antd'

import type { ChartType } from '../chartHeuristic'

const LABELS: Record<ChartType, string> = {
  bar: 'Barre',
  line: 'Linea',
  number: 'Numero',
  table: 'Solo tabella',
}

// Ordine fisso di visualizzazione dei bottoni.
const ORDER: ChartType[] = ['bar', 'line', 'number', 'table']

interface ChartTypeSwitchProps {
  value: ChartType
  onChange: (type: ChartType) => void
  /** Tipi abilitati per la forma corrente dei dati (calcolati dal genitore). */
  enabled: ChartType[]
}

function ChartTypeSwitch({ value, onChange, enabled }: ChartTypeSwitchProps) {
  return (
    <Radio.Group
      value={value}
      onChange={(e) => onChange(e.target.value as ChartType)}
      optionType="button"
      buttonStyle="solid"
      size="small"
    >
      {ORDER.map((t) => (
        <Radio.Button key={t} value={t} disabled={!enabled.includes(t)}>
          {LABELS[t]}
        </Radio.Button>
      ))}
    </Radio.Group>
  )
}

export default ChartTypeSwitch
